import TranslationStore from './TranslationStore';

export default function translate(label, params = []) {
  const translation = TranslationStore.get(label);
  return params.reduce((acc, value) => acc.replace('%s', value), translation);
}
